import { useState } from 'react';

import { Duty, Absence } from 'RestAPIs/roster/types';
import { Interval, PlanUnit } from 'components/types';

import { getMonthInterval, fromISOString } from 'utils/date';
import { getLocalState, updateLocalState } from 'utils/localStorage';

import { getTeamRosterData } from 'RestAPIs/roster';

import RosterViewByDuty from 'components/shared/roster/RosterViewByDuty/RosterViewByDuty';

const getData = (interval: Interval, selectedPlanUnits: PlanUnit[]) =>
  new Promise<{
    duties: Duty[];
    absences: Absence[];
  }>((resolve, reject) => {
    getTeamRosterData(interval, selectedPlanUnits, false).then(
      ({ data }) => {
        const { duties, absences } = data;
        resolve({ duties, absences });
      },
      () => {
        reject();
      }
    );
  });

type Props = {
  portal: 'employee' | 'roster';
  onRosterViewChanged?: (rosterView: 'employees' | 'duties') => void;
};

export default function TeamRosterViewByDuty({
  portal,
  onRosterViewChanged
}: Props) {
  const localState = getLocalState().employeePortal?.teamRoster;
  const [selectedPlanUnits, setSelectedPlanUnits] = useState<PlanUnit[]>([]);
  const [isGroupedByPlanunit, setIsGroupedByPlanunit] = useState(
    localState?.duties?.isGroupedByPlanUnit || false
  );
  const [isGroupedByFunction, setIsGroupedByFunction] = useState(
    localState?.duties?.isGroupedByFunction || false
  );

  const onPlanUnitSelected = (value: PlanUnit[]) => {
    updateLocalState({
      employeePortal: {
        teamRoster: {
          lastSelectedPlanUnitsIds: value.map(({ uniqId }) => uniqId)
        }
      }
    });
    setSelectedPlanUnits(value);
  };

  const toggleGroupByPlanUnit = () => {
    const value = !isGroupedByPlanunit;
    setIsGroupedByPlanunit(value);
    updateLocalState({
      employeePortal: {
        teamRoster: {
          duties: { isGroupedByPlanUnit: value }
        }
      }
    });
  };

  const toggleGroupByFunction = () => {
    const value = !isGroupedByFunction;
    setIsGroupedByFunction(value);
    updateLocalState({
      employeePortal: {
        teamRoster: {
          duties: { isGroupedByFunction: value }
        }
      }
    });
  };

  return (
    <RosterViewByDuty
      getData={getData}
      selectedPlanUnits={selectedPlanUnits}
      lastSelectedPlanUnitsIds={
        window.teamRosterTempCostCenters?.map(({ brId }) => brId) ||
        localState?.lastSelectedPlanUnitsIds
      }
      onPlanUnitSelected={onPlanUnitSelected}
      isGroupedByPlanunit={isGroupedByPlanunit}
      onToggleGroupByPlanUnit={toggleGroupByPlanUnit}
      isGroupedByFunction={isGroupedByFunction}
      onToggleGroupByFunction={toggleGroupByFunction}
      defaultInterval={
        window.teamRosterTempDate
          ? getMonthInterval(fromISOString(window.teamRosterTempDate))
          : undefined
      }
      portal={portal}
      onRosterViewChanged={onRosterViewChanged}
    />
  );
}
